import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface BuyerPricingPlansProps {
  billingPeriod: "monthly" | "annually";
}

const BuyerPricingPlans = ({ billingPeriod }: BuyerPricingPlansProps) => {
  const features = [
    { text: "Unlimited property search & filtering" },
    { text: "Save up to 8 custom searches" },
    { text: "Save unlimited properties" },
    { text: "Follow unlimited sellers" },
    { text: "Real-time property alerts" },
    { text: "Mobile & desktop access" }
  ];

  return (
    <div className="flex justify-center">
      <Card className="bg-gray-800 border-[#ffd700] border-2 relative max-w-md w-full">
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <Badge className="bg-[#ffd700] text-[#080c14]">MOST POPULAR</Badge>
        </div>
        <CardHeader className="pt-8">
          <CardTitle className="text-2xl">Investor Access</CardTitle>
          <CardDescription className="text-gray-300">
            Everything you need to find and secure investment properties
          </CardDescription>
          <div className="flex items-center justify-center gap-2 mt-4">
            <span className="text-4xl font-bold text-[#ffd700]">Free</span>
          </div>
          <p className="text-sm text-[#ffd700]">No credit card required</p>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-[#ffd700]" />
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
          
          <div className="pt-4">
            <Link to="/buyer/register">
              <Button className="w-full bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] py-3 text-lg font-semibold">
                Create Free Account
              </Button>
            </Link>
            <p className="text-center text-sm text-gray-400 mt-2">
              Always free for buyers
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BuyerPricingPlans;